import { Injectable } from '@angular/core';

import { StatePersistServiceRegistry } from './state-storage-persist-service.registry';
import { ISavedState } from './state-storage.model';

@Injectable({ providedIn: 'root' })
export default class StateConverterService {
    constructor(private statePersistServices: StatePersistServiceRegistry) {}

    convert(state: any): ISavedState {
        return Object.entries(state)
            .map(([key, value]) => ({ feature: key, state: value }))
            .reduce((aggregate, current) => {
                const service = this.statePersistServices.get(current.feature);
                if (service) {
                    //@ts-ignore no way around refactoring this one since ISavedState is an empty interface :)
                    aggregate[current.feature] = service.save(current.state);
                }

                return aggregate;
            }, {} as ISavedState);
    }
}
